import(/* webpackMode: "eager", webpackExports: ["VideoGenerationSidePanel"] */ "/app/apps/sb-shell/app/(darkHeader)/ai/video-generation/_components/VideoGenerationSidePanel.tsx");
